import AccesoRepository from '@/services/AccesoRepository'

export default {
  namespaced: true,
  state: {
    esAdmin: false,
    isEsAdminSet: false,
  },
  mutations: {
    setEsAdmin(state, esAdmin) {
      state.esAdmin = esAdmin
      state.isEsAdminSet = true
    },

    clearEsAdmin(state) {
      state.esAdmin = false
      state.isEsAdminSet = false
    },
  },
  actions: {
    async fetchEsAdmin({state, commit}) {
      if (state.isEsAdminSet) {
        return
      }

      let esAdmin = await AccesoRepository.esAdmin()
      commit('setEsAdmin', esAdmin)
    },

    clearEsAdmin({commit}) {
      commit('clearEsAdmin')
    },
  }
}
